import gql from 'graphql-tag';

const GET_SCRIPT_VIEWS = gql`
  query {
    getScriptViews {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const ASSET_SCRIPT_LIST_RETURN_TYPE = `
  assetScripts {
    scriptId
    name
    description
    custom
    language
    # content
    addedBy {
      name
    }
    createdTime
    favourite
    runAs
    runTimeVariables
    runTimeVars
    # scriptVariables {
    #   runTime {
    #     name
    #   }
    #   placeHolders {
    #     name
    #   }
    # }
    # timeOut
    # additionalFiles {
    #   id
    #   scriptAdditionalFile {
    #     fileId
    #     fileName
    #     fileSize
    #   }
    #   destinationLocation
    # }
  }
  listInfo {
    page
    pageSize
    condition
    totalCount
    hasMore
    sort {
      attribute
      order
    }
  }
`;

const GET_ASSET_SCRIPT_LIST = gql`
  query($listInfo: ListInfoInput) {
    getAssetScriptList(listInfo: $listInfo) {
     ${ASSET_SCRIPT_LIST_RETURN_TYPE}
    }
  }
`;
const GET_ASSET_SCRIPT_LIST_V2 = gql`
  query($classId: ID!, $listInfo: ListInfoInput) {
    getAssetScriptListByClassId(classId: $classId, listInfo: $listInfo) {
     ${ASSET_SCRIPT_LIST_RETURN_TYPE}
    }
  }
`;
const GET_ASSET_SCRIPT_LIST_BY_CLASS_ID_AND_SCRIPT_TYPE = gql`
query ($classId: ID!, $scriptType: String, $listInfo: ListInfoInput) {
  getAssetScriptListByClassIdAndScriptType(classId: $classId, scriptType: $scriptType, listInfo: $listInfo) {
    # ${ASSET_SCRIPT_LIST_RETURN_TYPE}
  }
}
`;

const GET_ASSET_SCRIPT = gql`
  query($scriptId: ID!) {
    getAssetScript(scriptId: $scriptId) {
      scriptId
      name
      description
      custom
      language
      content
      addedBy {
        name
      }
      createdTime
      favourite
      runAs
      scriptVariables {
        runTime {
          name
        }
        placeHolders {
          name
          labelName
          columnName
        }
      }
      timeOut
      additionalFiles {
        id
        scriptAdditionalFile {
          fileId
          fileName
          fileSize
        }
        destinationLocation
      }
      readMe
      tags
      shared
      imported
      isUpdateAvailable
      communityScriptId
    }
  }
`;

const GET_AI_README = gql`
  query getAIScriptGenerationReadme($input: AIScriptGenerationReadmeInput!) {
    getAIScriptGenerationReadme(input: $input)
  }
`;
const GET_AI_SCRIPT_GENERATION = gql`
  query getAIScriptGeneration($input: AIScriptGenerationInput!) {
    getAIScriptGeneration(input: $input) {
      script
      suggestedVariables
    }
  }
`;
const TEST_SCRIPT_ON_ASSET = gql`
  mutation($assetId: ID!, $input: UserActionConfigInput!) {
    testScriptOnAsset(input: $input, assetId: $assetId) {
      actionId
      windowId
    }
  }
`;

const GET_ASSET_CLASS_BY_LANGUAGE = gql`
  query($languageId: ID!) {
    getAssetClassListByLanguageId(languageId: $languageId) {
      classId
      name
    }
  }
`;

const GET_RECENTLY_USED_ASSET = gql`
  query($module: String!, $classIds: [ID!]!) {
    getRecentlyUsedAsset(module: $module, classIds: $classIds) {
      name
      assetId
    }
  }
`;
const GET_SCRIPT_ADDITIONAL_FILE_LIST = gql`
  query($listInfo: ListInfoInput) {
    getScriptAdditionalFileList(listInfo: $listInfo) {
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
      }
      additionalFiles {
        fileId
        fileName
        fileSize
      }
    }
  }
`;

const GET_SCRIPTS_META_V2 = gql`
  query {
    getScriptsMetaV2
  }
`;

const GET_ASSET_PLACEHOLDERS_LIST = gql`
  query {
    getAssetPlaceholdersList
  }
`;

const GET_SCRIPT_LANGUAGES = gql`
  query {
    getScriptLanguages {
      languageId
      language
    }
  }
`;

const GET_SCRIPT_PLACEHOLDER_LIST = gql`
  query($languageId: ID) {
    getScriptPlaceholderList(languageId: $languageId)
  }
`;

const CREATE_ASSET_SCRIPT = gql`
  mutation($input: AssetScriptInput!) {
    createAssetScript(input: $input) {
      scriptId
      name
      description
      custom
      language
      content
      addedBy {
        name
      }
      createdTime
      favourite
      runAs
      scriptVariables {
        runTime {
          name
        }
        placeHolders {
          name
          labelName
        }
      }
      timeOut
      additionalFiles {
        id
        scriptAdditionalFile {
          fileId
          fileName
          fileSize
        }
        destinationLocation
      }
    }
  }
`;

const UPDATE_ASSET_SCRIPT = gql`
  mutation($scriptId: ID!, $input: AssetScriptInput!) {
    updateAssetScript(scriptId: $scriptId, input: $input) {
      scriptId
      name
      description
      custom
      language
      content
      addedBy {
        name
      }
      createdTime
      favourite
      runAs
      scriptVariables {
        runTime {
          name
        }
        placeHolders {
          name
          labelName
        }
      }
      timeOut
      additionalFiles {
        id
        scriptAdditionalFile {
          fileId
          fileName
          fileSize
        }
        destinationLocation
      }
    }
  }
`;

const DELETE_ASSET_SCRIPT = gql`
  mutation($scriptId: ID!) {
    deleteAssetScript(scriptId: $scriptId)
  }
`;

const GET_SCRIPT_DETAILS = gql`
  query getActionDetails($actionId: ID!) {
    getActionDetails(actionId: $actionId) {
      statusMessage
    }
  }
`;

// save script content - http://localhost:8092/rmm/scripts/<scriptid>/content {content: text}}
// upload script additional file - http://localhost:8092/rmm/uploadTempFiles {files: [<file>,<file>]}

export {
  GET_SCRIPT_VIEWS,
  GET_ASSET_SCRIPT,
  GET_ASSET_SCRIPT_LIST,
  GET_SCRIPT_ADDITIONAL_FILE_LIST,
  GET_ASSET_PLACEHOLDERS_LIST,
  CREATE_ASSET_SCRIPT,
  UPDATE_ASSET_SCRIPT,
  DELETE_ASSET_SCRIPT,
  GET_ASSET_SCRIPT_LIST_V2,
  GET_SCRIPTS_META_V2,
  GET_SCRIPT_LANGUAGES,
  GET_SCRIPT_PLACEHOLDER_LIST,
  GET_AI_SCRIPT_GENERATION,
  GET_ASSET_SCRIPT_LIST_BY_CLASS_ID_AND_SCRIPT_TYPE,
  TEST_SCRIPT_ON_ASSET,
  GET_ASSET_CLASS_BY_LANGUAGE,
  GET_SCRIPT_DETAILS,
  GET_AI_README,
  GET_RECENTLY_USED_ASSET
};
